import inlineSVG from './lib/inlineSVG.min'
import Modals from './lib/modals'
import CookieWidget from './cookieWidget.js'

document.addEventListener('DOMContentLoaded', () => {
  Modals()
    	const cookieWidget = new CookieWidget({
		cookieName: 'SarahFun',
		cookieExpiryHrs: 48, // Cookie на 48 часов
		cookieTheme: '',
    cookieScroll: 50,
		cookieHtml: null // Темная тема
	});

})

window.onload = function () {
  var st = document.getElementsByTagName('body');
  if (st) {
    st[0].classList.add('ld');
  }
};
//inline svg
inlineSVG.init({
  svgSelector: 'img.isvg', // the class attached to all images that should be inlined
  initClass: 'js-inlinesvg', // class added to <html>
}, function () {
  console.log('All SVGs inlined');
});
//ct sprite
var ajax = new XMLHttpRequest();
ajax.open("GET", "/i/ctsprite.svg", true);
ajax.send();
ajax.onload = function (e) {
  var svgdiv = document.getElementById("svgdiv");
  svgdiv.innerHTML = ajax.responseText;
  // document.body.insertBefore(svgdiv, document.body.childNodes[0]);
}
//js
// navigation
const nav = document.getElementById("topNav");
const supportPageOffset = window.scrollX !== undefined;
const isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
let previousScrollPosition = 0;
const isScrollingDown = () => {
  let scrolledPosition = supportPageOffset ? window.scrollY : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  let isScrollDown;
  if (scrolledPosition > previousScrollPosition) {
    isScrollDown = true;
  } else {
    isScrollDown = false;
  }
  previousScrollPosition = scrolledPosition;
  return isScrollDown;
};
const handleNavScroll = () => {
  if (isScrollingDown() && !nav.contains(document.activeElement)) {
    nav.classList.add("scroll-down");
    nav.classList.remove("scroll-up");
  } else {
    nav.classList.add("scroll-up");
    nav.classList.remove("scroll-down");
  }
};
var throttleTimer;
const throttle = (callback, time) => {
  if (throttleTimer) return;
  throttleTimer = true;
  setTimeout(() => {
    callback();
    throttleTimer = false;
  }, time);
};
const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
window.addEventListener("scroll", () => {
  if (mediaQuery && !mediaQuery.matches) {
    throttle(handleNavScroll, 150);
  }
});
window.addEventListener("scroll", function () {
  if (window.scrollY == 0) {
    nav.classList.add("scrolled-top");
  } else {
    nav.classList.remove("scrolled-top");
  }
});

// Sidebar block sticky
const $homePageMainBlock = document.querySelector('.mainBlock');
const $sidebarScrollBlock = document.querySelector('.sidead');

// Проверяем, существуют ли необходимые элементы
if ($sidebarScrollBlock) {
  const $sidebar = $sidebarScrollBlock.parentNode;
  
  function sidebarSticky() {
    if (!$sidebar) return; // Дополнительная проверка
    
    const scrolledYPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    const innerOffset = $sidebar.offsetTop + $sidebar.offsetHeight - nav.offsetHeight - $sidebarScrollBlock.offsetHeight;
    
    if (scrolledYPosition > $sidebar.offsetTop - nav.offsetHeight + 13) {
      $sidebarScrollBlock.style.position = 'fixed';
      $sidebarScrollBlock.style.left = `${$sidebar.offsetLeft}px`;
      
      if (scrolledYPosition > innerOffset) {
        $sidebarScrollBlock.style.top = `${innerOffset - scrolledYPosition + nav.offsetHeight}px`;
      } else {
        $sidebarScrollBlock.style.top = `${$sidebar.offsetTop}px`;
      }
      
      $sidebarScrollBlock.style.width = `${$sidebar.offsetWidth}px`;
    } else {
      $sidebarScrollBlock.style.position = 'static';
      $sidebarScrollBlock.style.left = '0';
      $sidebarScrollBlock.style.top = '0';
      $sidebarScrollBlock.style.width = 'auto';
    }
  }

  if (!$homePageMainBlock) {
    window.addEventListener('scroll', sidebarSticky);
    window.addEventListener('resize', () => {
      if ($sidebar) {
        $sidebarScrollBlock.style.left = `${$sidebar.offsetLeft}px`;
      }
    });
  }
}